<template>
  <div class="hris-page" v-if="show">
    <div class="hris-page-inner">
      <div class="hris-page-header hris-page-header-row">
        <div>
          <span class="hris-page-eyebrow">Leaves</span>
          <h1 class="hris-page-title">All Employee Applications</h1>
          <p class="hris-page-subtitle">Review and bulk-process employee leave applications.</p>
        </div>
        <q-btn unelevated class="hris-q-primary" :loading="loading" @click="processAll" label="Process Applications" no-caps>
          <template v-slot:loading>
            <q-spinner color="white" class="on-left"></q-spinner>
            Processing...
          </template>
        </q-btn>
      </div>

      <template v-if="is_pto_enabled">
        <div class="hris-panel">
          <div class="hris-panel-title">Leave Applications</div>
          <q-table flat :data="combinedPaidLeaves" :columns="ResultColumns" :pagination.sync="unifiedPagination" row-key="uniqueId" dense selection="multiple" :selected.sync="paidSelected">
            <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails(props.row.type, props.row.id)">
              <q-td>
                <q-checkbox dense v-model="props.selected"></q-checkbox>
              </q-td>
              <q-td key="status" :props="props">{{ props.row.status }}</q-td>
              <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
              <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
              <q-td key="name" :props="props">{{ props.row.name }}</q-td>
              <q-td key="department" :props="props">{{ props.row.department }}</q-td>
            </q-tr>
            <template v-slot:no-data>
              <div class="hris-empty full-width">No Applications Yet</div>
            </template>
          </q-table>
        </div>
      </template>

      <template v-else>
        <div class="hris-panel" key="el">
          <div class="hris-panel-title">Emergency Leave</div>
          <q-table flat :data="elAppResultData" :columns="ResultColumns" :pagination.sync="elPagination" row-key="id" dense selection="multiple" :selected.sync="elSelected">
            <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('elApp',props.row.id)">
              <q-td>
                <q-checkbox dense v-model="props.selected"></q-checkbox>
              </q-td>
              <q-td key="status" :props="props">{{ props.row.status }}</q-td>
              <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
              <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
              <q-td key="name" :props="props">{{ props.row.name }}</q-td>
              <q-td key="department" :props="props">{{ props.row.department }}</q-td>
            </q-tr>
            <template v-slot:no-data>
              <div class="hris-empty full-width">No Applications Yet</div>
            </template>
          </q-table>
        </div>
        <div class="hris-panel" key="vl">
          <div class="hris-panel-title">Vacation Leave</div>
          <q-table flat :data="vlAppResultData" :columns="ResultColumns" :pagination.sync="vlPagination" row-key="id" dense selection="multiple" :selected.sync="vlSelected">
            <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('vlApp',props.row.id)">
              <q-td>
                <q-checkbox dense v-model="props.selected"></q-checkbox>
              </q-td>
              <q-td key="status" :props="props">{{ props.row.status }}</q-td>
              <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
              <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
              <q-td key="name" :props="props">{{ props.row.name }}</q-td>
              <q-td key="department" :props="props">{{ props.row.department }}</q-td>
            </q-tr>
            <template v-slot:no-data>
              <div class="hris-empty full-width">No Applications Yet</div>
            </template>
          </q-table>
        </div>
        <div class="hris-panel" key="sl">
          <div class="hris-panel-title">Sick Leave</div>
          <q-table flat :data="slAppResultData" :columns="ResultColumns" :pagination.sync="slPagination" row-key="id" dense selection="multiple" :selected.sync="slSelected">
            <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('slApp',props.row.id)">
              <q-td>
                <q-checkbox dense v-model="props.selected"></q-checkbox>
              </q-td>
              <q-td key="status" :props="props">{{ props.row.status }}</q-td>
              <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
              <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
              <q-td key="name" :props="props">{{ props.row.name }}</q-td>
              <q-td key="department" :props="props">{{ props.row.department }}</q-td>
            </q-tr>
            <template v-slot:no-data>
              <div class="hris-empty full-width">No Applications Yet</div>
            </template>
          </q-table>
        </div>
      </template>

      <div class="hris-panel" key="ml">
        <div class="hris-panel-title">Maternity Leave</div>
        <q-table flat :data="mlAppResultData" :columns="ResultColumns" :pagination.sync="mlPagination" row-key="id" dense selection="multiple" :selected.sync="mlSelected">
          <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('mlApp',props.row.id)">
            <q-td>
              <q-checkbox dense v-model="props.selected"></q-checkbox>
            </q-td>
            <q-td key="status" :props="props">{{ props.row.status }}</q-td>
            <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
            <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          </q-tr>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No Applications Yet</div>
          </template>
        </q-table>
      </div>
      <div class="hris-panel" key="pl">
        <div class="hris-panel-title">Paternity Leave</div>
        <q-table flat :data="plAppResultData" :columns="ResultColumns" :pagination.sync="plPagination" row-key="id" dense selection="multiple" :selected.sync="plSelected">
          <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('plApp',props.row.id)">
            <q-td>
              <q-checkbox dense v-model="props.selected"></q-checkbox>
            </q-td>
            <q-td key="status" :props="props">{{ props.row.status }}</q-td>
            <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
            <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          </q-tr>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No Applications Yet</div>
          </template>
        </q-table>
      </div>
      <div class="hris-panel" key="mc">
        <div class="hris-panel-title">Magna Carta Leave</div>
        <q-table flat :data="mcAppResultData" :columns="ResultColumns" :pagination.sync="mcPagination" row-key="id" dense selection="multiple" :selected.sync="mcSelected">
          <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails('mcApp',props.row.id)">
            <q-td>
              <q-checkbox dense v-model="props.selected"></q-checkbox>
            </q-td>
            <q-td key="status" :props="props">{{ props.row.status }}</q-td>
            <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
            <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          </q-tr>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No Applications Yet</div>
          </template>
        </q-table>
      </div>
      <div class="hris-panel" key="sp">
        <div class="hris-panel-title">Solo Parent Leave</div>
        <q-table flat :data="spAppResultData" :columns="ResultColumns" :pagination.sync="spPagination" row-key="id" dense selection="multiple" :selected.sync="spSelected">
          <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer" @click="viewDetails(props.row.type || 'spApp', props.row.id)">
            <q-td>
              <q-checkbox dense v-model="props.selected"></q-checkbox>
            </q-td>
            <q-td key="status" :props="props">{{ props.row.status }}</q-td>
            <q-td key="date_applied" :props="props">{{ props.row.date_applied }}</q-td>
            <q-td key="inclusive_dates" :props="props">{{ props.row.inclusive_dates }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          </q-tr>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No Applications Yet</div>
          </template>
        </q-table>
      </div>
    </div>

    <q-dialog v-model="loadingModel" persistent>
      <div class="hris-loading" style="background: transparent; min-width: 200px;">
        <q-spinner color="green" size="3em"></q-spinner>
        <div>{{ loadingText }}</div>
      </div>
    </q-dialog>

    <q-dialog v-model="leaveDetailsDialog" persistent transition-show="scale" transition-hide="scale">
      <div class="hris-modal hris-modal-lg">
        <div class="hris-modal-header">
          <div>
            <h2 class="hris-modal-title">Leave Application Details</h2>
            <p class="hris-modal-subtitle">Leave Type: {{ leaveType }}</p>
          </div>
          <q-btn flat dense round v-close-popup aria-label="Close">
            <i class="fas fa-times"></i>
          </q-btn>
        </div>
        <div class="hris-modal-body">
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input :value="viewLeaveDetails.status" label="Status" outlined readonly stack-label dense color="green"></q-input>
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input :value="viewLeaveDetails.employee_name" label="Employee Name" outlined readonly stack-label dense color="green"></q-input>
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input :value="viewLeaveDetails.employee_department" label="Department" outlined readonly stack-label dense color="green"></q-input>
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input :value="viewLeaveDetails.date_applied" label="Date Applied" outlined readonly stack-label dense color="green"></q-input>
            </div>
            <div class="hris-form-field">
              <q-input :value="viewLeaveDetails.total_days" label="Total Days" outlined readonly stack-label dense color="green"></q-input>
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input :value="viewLeaveDetails.date_start" label="Date Start" outlined readonly stack-label dense color="green"></q-input>
            </div>
            <div class="hris-form-field">
              <q-input :value="viewLeaveDetails.date_end" label="Date End" outlined readonly stack-label dense color="green"></q-input>
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input :value="viewLeaveDetails.reason" label="Reason" type="textarea" outlined readonly stack-label dense color="green"></q-input>
            </div>
          </div>
          <template v-if="viewLeaveDetails.status != 'Pending'">
            <div class="hris-form-row">
              <div class="hris-form-field">
                <q-input :value="viewLeaveDetails.approver" label="Processed By" outlined readonly stack-label dense color="green"></q-input>
              </div>
              <div class="hris-form-field">
                <q-input :value="viewLeaveDetails.date_processed" label="Date Processed" outlined readonly stack-label dense color="green"></q-input>
              </div>
            </div>
            <div class="hris-form-row">
              <div class="hris-form-field" style="flex-basis: 100%;">
                <q-input :value="viewLeaveDetails.approver_remarks" label="Remarks" type="textarea" outlined readonly stack-label dense color="green"></q-input>
              </div>
            </div>
          </template>
        </div>
        <div class="hris-modal-footer">
          <q-btn unelevated class="hris-q-outline" label="Close" v-close-popup no-caps></q-btn>
        </div>
      </div>
    </q-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import { date } from 'quasar';
export default {
  name: 'EmployeeApplications_Leave',
  data() {
    return {
      show: true,
      loading: false,
      loadingModel: false,
      loadingText: '',
      is_pto_enabled: false,
      leaveDetailsDialog: false,
      leaveType: '',
      viewLeaveDetails: {},
      applications: {},
      elAppResultData: [],
      vlAppResultData: [],
      slAppResultData: [],
      mlAppResultData: [],
      plAppResultData: [],
      mcAppResultData: [],
      spAppResultData: [],
      elSelected: [],
      vlSelected: [],
      slSelected: [],
      mlSelected: [],
      plSelected: [],
      mcSelected: [],
      spSelected: [],
      paidSelected: [],
      elPagination: { rowsPerPage: 5 },
      vlPagination: { rowsPerPage: 5 },
      slPagination: { rowsPerPage: 5 },
      mlPagination: { rowsPerPage: 5 },
      plPagination: { rowsPerPage: 5 },
      mcPagination: { rowsPerPage: 5 },
      spPagination: { rowsPerPage: 5 },
      unifiedPagination: { rowsPerPage: 10 },
      ResultColumns: [
        { name: 'status', field: 'status', label: 'Status', align: 'center' },
        { name: 'date_applied', field: 'date_applied', label: 'Date Applied', align: 'center' },
        { name: 'inclusive_dates', field: 'inclusive_dates', label: 'Inclusive Dates', align: 'center' },
        { name: 'name', field: 'name', label: 'Name', align: 'center' },
        { name: 'department', field: 'department', label: 'Department', align: 'center' }
      ]
    }
  },
  computed: {
    hasUnifiedLeaveFeature: function() {
      return (this.userData.features || []).includes('pto');
    },
    combinedPaidLeaves: function() {
      return [...this.elAppResultData.map(d => ({...d, type: 'elApp', uniqueId: 'el_'+d.id})), 
              ...this.vlAppResultData.map(d => ({...d, type: 'vlApp', uniqueId: 'vl_'+d.id})), 
              ...this.slAppResultData.map(d => ({...d, type: 'slApp', uniqueId: 'sl_'+d.id}))];
    }
  },
  methods: {
    loadStatus: function() {
      this.is_pto_enabled = this.hasUnifiedLeaveFeature;
    },
    loadApplications: function() {
      this.loadingModel = true;
      this.loadingText = 'Retrieving Applications';
      axios.create({
          baseURL: this.apiUrl,
          headers: { 'Authorization': `Bearer ${this.token}` }
        })
        .get('/leave/applications/retrieve-hr-list')
        .then((res) => {
          this.applications = res.data.data;
          Object.keys(this.applications).forEach((key) => {
            let appKey = key + "ResultData";
            this[appKey] = [];
            for (let eachApp of this.applications[key]) {
              let tempDate = date.extractDate(eachApp.date_applied, 'YYYY-MM-DD HH:mm:ss');
              let date_applied = date.formatDate(tempDate, 'MMMM DD, YYYY');
              let tempIncDate = eachApp.inclusive_dates.split('/');
              let finalIncDate = '';
              if (tempIncDate[0] == tempIncDate[1]) {
                finalIncDate = date.formatDate(tempIncDate[0], 'MMMM DD, YYYY');
              } else {
                finalIncDate = date.formatDate(tempIncDate[0], 'MMMM DD') + ' - ' + date.formatDate(tempIncDate[1], 'DD, YYYY');
              }

              this[appKey].push({
                id: eachApp.id,
                status: eachApp.status,
                date_applied: date_applied,
                inclusive_dates: finalIncDate,
                name: eachApp.name,
                department: eachApp.department
              });
            }
          });
        })
        .finally(() => {
          this.loadingModel = false;
        })
    },
    viewDetails: function(leaveApp, rowID) {
      this.loadingModel = true;
      this.loadingText = 'Retrieving Details';
      axios.create({
          baseURL: this.apiUrl,
          headers: { 'Authorization': `Bearer ${this.token}` }
        })
        .get('/leave/applications/details', {
          params: { id: rowID, type: leaveApp }
        })
        .then((res) => {
          this.loadingModel = false;
          this.viewLeaveDetails = res.data.data;
          this.leaveDetailsDialog = true;
          
          let d = date.extractDate(this.viewLeaveDetails.date_applied, 'YYYY-MM-DD HH:mm:ss');
          this.viewLeaveDetails.date_applied = date.formatDate(d, 'MMMM DD, YYYY @ hh:mmA');
          this.viewLeaveDetails.date_start = date.formatDate(this.viewLeaveDetails.date_start, 'MMMM DD, YYYY');
          this.viewLeaveDetails.date_end = date.formatDate(this.viewLeaveDetails.date_end, 'MMMM DD, YYYY');
          
          if (this.viewLeaveDetails.status != 'Pending') {
            let dp = date.extractDate(this.viewLeaveDetails.date_processed, 'YYYY-MM-DD HH:mm:ss');
            this.viewLeaveDetails.date_processed = date.formatDate(dp, 'MMMM DD, YYYY @ hh:mmA');
          }

          const types = {
            'elApp': 'Emergency Leave',
            'vlApp': 'Vacation Leave',
            'slApp': 'Sick Leave',
            'mlApp': 'Maternity Leave',
            'plApp': 'Paternity Leave',
            'mcApp': 'Magna Carta Leave',
            'spApp': 'Solo Parent Leave'
          };
          this.leaveType = types[leaveApp] || 'Unknown';
        });
    },
    processAll: function() {
        let selected = [];
        if (this.is_pto_enabled) {
            selected = this.paidSelected.map(s => s.id);
        } else {
            selected = [...this.elSelected, ...this.vlSelected, ...this.slSelected, ...this.mlSelected, ...this.plSelected, ...this.mcSelected, ...this.spSelected].map(s => s.id);
        }
        
        if (selected.length === 0) {
            this.$q.notify({ color: 'red-6', message: 'No applications selected.' });
            return;
        }

        this.loading = true;
        axios.create({
            baseURL: this.apiUrl,
            headers: { 'Authorization': `Bearer ${this.token}` }
        }).post('/leave/applications/hr-process-all', selected).then(() => {
            this.loading = false;
            this.$q.notify({ color: 'green-7', message: 'Applications Processed' });
            this.loadApplications();
            this.elSelected = []; this.vlSelected = []; this.slSelected = []; this.mlSelected = []; this.plSelected = []; this.mcSelected = []; this.spSelected = []; this.paidSelected = [];
        });
    }
  },
  mounted() {
    this.loadStatus();
    this.loadApplications();
  }
}
</script>
<style lang="css" scoped>
</style>
